import React from 'react';
import { Input } from '../../Input';
import { FormInput, ErrorMessageComponent } from './style';

export const AuthenticationInput = props => (
    <Input errorComponent={ErrorMessageComponent} inputComponent={FormInput} {...props} />
);



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AuthenticationForms/AuthenticationInput.js